import { render, staticRenderFns } from "./InvoicesRecord.vue?vue&type=template&id=71f1f7eb&scoped=true"
import script from "./InvoicesRecord.vue?vue&type=script&lang=js"
export * from "./InvoicesRecord.vue?vue&type=script&lang=js"
import style0 from "./InvoicesRecord.vue?vue&type=style&index=0&id=71f1f7eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1f7eb",
  null
  
)

export default component.exports